import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var MailOutline = function MailOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84814 21.1201H20.3877C22.3667 21.1201 23.5151 19.9717 23.5151 17.7773V6.44678C23.5151 4.25244 22.3564 3.104 20.1416 3.104H3.60205C1.62305 3.104 0.474609 4.24219 0.474609 6.44678V17.7773C0.474609 19.9717 1.6333 21.1201 3.84814 21.1201ZM10.8413 12.4658L3.37646 5.08301C3.52002 5.05225 3.68408 5.03174 3.8584 5.03174H20.1313C20.3159 5.03174 20.48 5.05225 20.6338 5.09326L13.1792 12.4658C12.7485 12.8862 12.3896 13.0708 12.0103 13.0708C11.6309 13.0708 11.272 12.876 10.8413 12.4658ZM2.39209 6.59033L7.97021 12.0762L2.39209 17.5928V6.59033ZM16.0503 12.0762L21.5977 6.62109V17.5723L16.0503 12.0762ZM3.8584 19.1821C3.67383 19.1821 3.49951 19.1616 3.3457 19.1309L9.22119 13.3066L9.7749 13.8604C10.5234 14.5884 11.2412 14.896 12.0103 14.896C12.769 14.896 13.4971 14.5884 14.2354 13.8604L14.7993 13.3066L20.6646 19.1206C20.5005 19.1616 20.3262 19.1821 20.1313 19.1821H3.8584Z"
  })));
};

MailOutline.displayName = 'MailOutline';
export default MailOutline;